// removed by extract-text-webpack-plugin
module.exports = {"header":"header__19gRE","nav":"nav__1jI-L","link":"link__24W9n"};


//////////////////
// WEBPACK FOOTER
// ./components/navDrawer/style.css
// module id = kwc6
// module chunks = 6